const millisecondsInADay = 86400000;

export const daysSince = (sinceDate?: string): number => {
  if (!sinceDate) {
    return 1;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const waitingSince = new Date(sinceDate);
  waitingSince.setHours(0, 0, 0, 0);
  return Math.round(
    (today.getTime() - waitingSince.getTime()) / millisecondsInADay,
  );
};

export const toIsoString = (date?: string | Date): string | undefined => {
  if (!date) {
    return undefined;
  }

  const parsed = date instanceof Date ? date : new Date(date);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed.toISOString();
};

/**
 * Converts a date to an ISO date string.
 * @param date The Date object to convert.
 * @returns A date string in the following format: yyyy-mm-dd.
 */
export const toIsoDateString = (date?: string | Date): string | undefined => {
  if (!date) {
    return;
  }

  const isoString = toIsoString(date);
  if (!isoString) {
    return;
  }

  return isoString.split('T')[0];
};

/**
 * Converts a date to a 2-digit month and year.
 * @param date The Date object to convert.
 * @returns A date string in the following format: mm/yy.
 */
export const toTwoDigitDateString = (date?: Date): string | undefined => {
  if (!date) {
    return;
  }

  const options: Intl.DateTimeFormatOptions = {
    month: '2-digit',
    year: '2-digit',
  };

  return new Intl.DateTimeFormat('en-US', options).format(date);
};
